import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import {
  CLAIMSSEARCH_FEATURE_KEY,
  claimsSearchReducer,
} from './+state/claims-search.reducer';
import { ClaimsSearchEffects } from './+state/claims-search.effects';
import { ChcpSharedCodesetDataAccessModule } from '@cigna/chcp/shared/codeset-data-access';

@NgModule({
  imports: [
    CommonModule,
    ChcpSharedCodesetDataAccessModule,
    StoreModule.forFeature(CLAIMSSEARCH_FEATURE_KEY, claimsSearchReducer),
    EffectsModule.forFeature([ClaimsSearchEffects]),
  ],
})
export class ChcpClaimsSharedDataAccessModule {}
